import React from "react";
import { apps } from "../../../url";
import { trackMembraneBuilderClick } from "../../../analytics";

interface ClipboardModalProps {
  isOpen: boolean;
  onClose: () => void;
  text: string;
  isBroadPharm: boolean;
  lnpId: string;
}

const ClipboardModal: React.FC<ClipboardModalProps> = ({
  isOpen,
  onClose,
  text,
  isBroadPharm,
  lnpId,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-lg mx-4 bg-white rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">
            {lnpId.toUpperCase()} - Copied to Clipboard
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <span className="sr-only">Close</span>
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="p-6">
          {isBroadPharm && (
            <div className="flex items-start p-3 mb-4 text-sm text-yellow-800 border border-yellow-200 rounded-md bg-yellow-50">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 w-5 h-5 mr-2 text-yellow-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
              <div>
                <p className="mb-1 font-bold">Notice :</p>
                <p>
                  BroadPharm is a supplier and may not provide formulation
                  details for specific ionizable lipids. For Membrane Builder
                  convenience, MolCube applies a Moderna reference formulation
                  as a default and copies the Upper/Lower leaflet composition to
                  your clipboard.
                </p>
              </div>
            </div>
          )}

          <div className="mb-4">
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Copied Text
            </label>
            <textarea
              className="w-full p-2 font-mono text-sm text-center border border-gray-300 rounded-md resize-none bg-gray-50 focus:outline-none"
              readOnly
              value={text}
            />
          </div>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Done
            </button>
            <a
              href={`${apps}/builder/m/membrane-builder/quick-bilayer?lipidText=${encodeURIComponent(
                text,
              )}&utm_source=lnpdb&utm_medium=referral&utm_campaign=membrane_builder`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackMembraneBuilderClick(lnpId)}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Go to Membrane Builder
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClipboardModal;
